import {
  createFrontendModule,
  createTranslationMessages,
} from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { catalogTranslationRef } from '@backstage/plugin-catalog';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react';
import { coreComponentsTranslationRef } from '@backstage/core-components';

const catalogMessages = TranslationBlueprint.make({
  name: 'catalog-messages',
  params: {
    resource: createTranslationMessages({
      ref: catalogTranslationRef,
      messages: {
        'indexPage.createButtonTitle': 'Actions',
      },
    }),
  },
});

const catalogReactMessages = TranslationBlueprint.make({
  name: 'catalog-react-messages',
  params: {
    resource: createTranslationMessages({
      ref: catalogReactTranslationRef,
      messages: {
        'entitySearchBar.placeholder': 'Search',
      },
    }),
  },
});

// Rows-per-page select: show just the number ("20"), not "20 rows". This
// applies to every paged table in the app. "Rows per page:" is shown next to
// it by the catalog table footer.
const coreComponentsMessages = TranslationBlueprint.make({
  name: 'core-components-messages',
  params: {
    resource: createTranslationMessages({
      ref: coreComponentsTranslationRef,
      messages: {
        'table.pagination.labelRowsSelect': '',
      },
    }),
  },
});

export const translationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [catalogMessages, catalogReactMessages, coreComponentsMessages],
});
